import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { Directive, ElementRef, HostBinding, Injectable, Injector, Input, OnDestroy } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { AbstractControl, FormControl, NgControl, ValidationErrors } from '@angular/forms';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

let nextId = 0;

/*
https://material.angular.io/guide/creating-a-custom-form-field-control
 */
@Directive()
export class MatFormFieldControlBase<T>
    extends ControlValueAccessorValidatorBase<T>
    implements MatFormFieldControl<T>, OnDestroy
{
    get value() {
        return this.ngModel;
    }
    set value(v) {
        this.ngModel = v;
        this.stateChanges.next();
    }
    stateChanges = new Subject<void>();

    @HostBinding()
    id = `fi-mat-form-field-control-${nextId++}`;

    @Input()
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(plh) {
        this._placeholder = plh;
        this.stateChanges.next();
    }
    private _placeholder: string;

    focused = false;

    get empty() {
        return !this.value;
    }

    @HostBinding('class.floating')
    get shouldLabelFloat() {
        return this.focused || !this.empty;
    }

    @Input()
    get required() {
        return this._required;
    }
    set required(req) {
        this._required = coerceBooleanProperty(req);
        this.stateChanges.next();
    }
    private _required = false;

    @Input()
    get disabled(): boolean {
        return this._disabled;
    }
    set disabled(value: boolean) {
        this._disabled = coerceBooleanProperty(value);
        this.stateChanges.next();
    }
    private _disabled = false;

    errorState = false;

    controlType = 'fi-mat-form-field-control';

    protected elRef: ElementRef<HTMLElement>;

    @HostBinding('attr.aria-describedby') describedBy = '';
    setDescribedByIds(ids: string[]) {
        this.describedBy = ids.join(' ');
    }

    onContainerClick(event: MouseEvent) {
        if ((event.target as Element).tagName.toLowerCase() != 'input') {
            //this.elRef.nativeElement.querySelector('input').focus();
        }
    }

    ngControl: NgControl;

    constructor(protected injector: Injector) {
        super(injector);

        this.ngControl = injector.get(NgControl);
        this.ngControl.valueAccessor = this;
        this.ngControl.control.setValidators(this.validate.bind(this));
        this.elRef = injector.get(ElementRef);
        injector
            .get(FocusMonitor)
            .monitor(this.elRef.nativeElement, true)
            .subscribe((origin) => {
                this.focused = !!origin;
                this.stateChanges.next();
            });
    }

    validate(c: AbstractControl): ValidationErrors {
        const result = super.validate(c);
        this.errorState = !!result;
        return result;
    }

    ngOnDestroy() {
        this.stateChanges.complete();
    }
}
